import CustomPagination from "./CustomPagination";

interface DataTablePaginationProps {
  rowsPerPage: number;
  rowCount: number;
  currentPage: number;
  direction?: string;
  onChangePage: (page: number, totalRows: number) => void;
  onChangeRowsPerPage: (currentRowsPerPage: number, currentPage: number) => void;
}

const DataTableCustomPagination: React.FC<DataTablePaginationProps> = ({
    rowsPerPage,
    rowCount,
    currentPage,
    onChangePage,
    onChangeRowsPerPage
}) => {
    const totalPages = Math.ceil(rowCount / rowsPerPage);

    const handlePageChange = (page: number): void => {
        onChangePage(page, rowCount);
    };

    const handleRecordsPerPageChange = (newRowsPerPage: number): void => {
        onChangeRowsPerPage(newRowsPerPage, currentPage);
    };

    return (
        <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            recordsPerPage={rowsPerPage}
            totalRecords={rowCount}
            onRecordsPerPageChange={handleRecordsPerPageChange}
        />
    );
};

export default DataTableCustomPagination;